import request from '../utils/http'
// 机构信息
export function index (query) {
  return request({
    url: '/mechanism/list',
    method: 'GET',
    params: query
  })
}
// 新增机构
export function save (query) {
  return request({
    url: '/mechanism/save',
    method: 'POST',
    data: query
  })
}
// 编辑机构
export function edit (query) {
  return request({
    url: '/mechanism/edit',
    method: 'GET',
    params: query
  })
}
// 更新机构
export function update (query) {
  return request({
    url: '/mechanism/update',
    method: 'POST',
    data: query
  })
}
// 机构开关
export function show (query) {
  return request({
    url: '/mechanism/show',
    method: 'POST',
    data: query
  })
}
// 删除机构
export function del (query) {
  return request({
    url: '/mechanism/delete',
    method: 'DELETE',
    data: query
  })
}
// 导出机构数据
export function mechanismExport (query) {
  return request({
    url: '/mechanism/export',
    method: 'POST',
    responseType: 'blob',
    data: query
  })
}



// WEBPACK FOOTER //
// ./src/api/mechanism.js